import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { ref, watch } from "vue";
import ModalComp from "@/components/ui/ModalComp.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelOrderModal',
  props: {
    isVisible: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["update:isVisible", "confirm"],
  setup(__props: any) {

const props = __props;


const options = [
  { value: "PRODUCTS_UNAVAILABLE", label: "Produits indisponibles" },
  { value: "CANNOT_FULFILL", label: "Impossible de préparer la commande" },
  { value: "BUYER_REQUEST", label: "Annulation demandée par l’acheteur" },
  { value: "OTHER", label: "Autre" },
];

const reason = ref("");
const detail = ref("");

watch(reason, (value) => {
  if (value !== "OTHER") detail.value = "";
});

watch(
  () => props.isVisible,
  (visible) => {
    if (visible) {
      reason.value = "";
      detail.value = "";
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComp, {
    "is-visible": _ctx.isVisible,
    title: "Annuler la commande",
    size: "sm",
    "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:isVisible', $event)))
  }, {
    body: _withCtx(() => [
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-3 text-sm text-gray-700" }, "Pourquoi souhaitez-vous annuler cette commande ?", -1)),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
        return _createElementVNode("label", {
          key: option.value,
          class: "mb-2 flex cursor-pointer items-center gap-2 rounded-lg border p-3"
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
            type: "radio",
            value: option.value
          }, null, 8, _hoisted_1), [
            [_vModelRadio, reason.value]
          ]),
          _createElementVNode("span", null, _toDisplayString(option.label), 1)
        ])
      }), 64)),
      (reason.value === 'OTHER')
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 0,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((detail).value = $event)),
            maxlength: "500",
            rows: "4",
            placeholder: "Précisez la raison",
            class: "mt-2 w-full rounded-lg border border-gray-300 p-3"
          }, null, 512)), [
            [_vModelText, detail.value]
          ])
        : _createCommentVNode("", true),
      (reason.value === 'OTHER')
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: _normalizeClass(['mt-1 text-right text-xs', detail.value.length >= 450 ? 'text-red-600' : 'text-gray-500'])
          }, _toDisplayString(detail.value.length) + " / 500 caractères ", 3))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "rounded-lg border border-gray-300 px-4 py-2 text-sm",
        disabled: _ctx.loading,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:isVisible', false)))
      }, " Retour ", 8, _hoisted_2),
      _createElementVNode("button", {
        type: "button",
        class: "rounded-lg bg-red-600 px-4 py-2 text-sm text-white disabled:opacity-50",
        disabled: _ctx.loading || !reason.value || (reason.value === 'OTHER' && !detail.value.trim()),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('confirm', reason.value, reason.value === 'OTHER' ? detail.value.trim() : undefined)))
      }, _toDisplayString(_ctx.loading ? "Annulation..." : "Confirmer l'annulation"), 9, _hoisted_3)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})